import React from 'react';
// import M from 'materialize-css';

interface Select_Prop_t {
  options?: any;
  name?: any;
  title?: any;
  onChange?: any;
  disabledOptions?: any[] | undefined;
  disabled?: boolean;
  value?: string | undefined;
  id?: string | undefined;
}
export default function Select({ options, name, title, onChange, disabledOptions = [], disabled, value = "", id = '' }: Select_Prop_t) {
  return (
    <select name={name} className="browser-default" onChange={onChange} value={value || title} disabled={disabled} id={id}>
      {
        title ?
          <option value={title} disabled>{title}</option>
          : null
      }
      {
        options.map((option: string, i: number) => (
          <option key={i} value={option} disabled={disabledOptions.indexOf(option) >= 0}>{option}</option>
        ))
      }
    </select>
  )
}